import { Link } from 'react-router';

import { getHomepageUrl } from '@cartwhl/common/utils/getHomepageUrl';
import Logo from '@cartwhl/ui/atoms/Logo';

interface WordmarkProps {
  decorative?: boolean;
  large?: boolean;
}

export default function Wordmark({
  decorative = false,
  large = false,
}: WordmarkProps) {
  const content = large ? (
    <Logo className="block h-auto w-full text-green-50" />
  ) : (
    <Logo className="h-auto w-30 shrink-0 text-green-50 lg:w-46" />
  );

  if (decorative) {
    return <span aria-hidden="true" className="block w-full">{content}</span>;
  }

  const isOnHomepage =
    typeof window === 'undefined' ||
    getHomepageUrl('/') === `${window.location.origin}/`;

  if (isOnHomepage) {
    return (
      <Link
        to="/"
        className="inline-flex shrink-0 items-center outline-none"
        aria-label="Cartwheel home"
      >
        {content}
      </Link>
    );
  }

  return (
    <a
      href={getHomepageUrl('/')}
      className="inline-flex shrink-0 items-center outline-none"
      aria-label="Cartwheel home"
    >
      {content}
    </a>
  );
}
